import { useEffect, useMemo, useState } from 'react';
import { getGeoInsights, unwrapGeoPayload } from '../../../api';

/** Fetches aggregated GEO insights for the dashboard (mirrors SEC insights fetch in SecFilingTracker). */
export default function useGeoInsights({ insightsParams = {}, enabled = true } = {}) {
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const paramsKey = useMemo(() => JSON.stringify(insightsParams || {}), [insightsParams]);

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getGeoInsights(insightsParams);
        if (!cancelled) {
          setInsights(unwrapGeoPayload(response) || null);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err?.message || 'Failed to load Prompt Pulse insights');
          setInsights(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    const timer = window.setTimeout(load, 150);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [paramsKey, enabled, insightsParams]);

  return { insights, loading, error };
}
